import { render, staticRenderFns } from "./page.footer.vue?vue&type=template&id=640f6b36&scoped=true&"
import script from "./page.footer.vue?vue&type=script&lang=js&"
export * from "./page.footer.vue?vue&type=script&lang=js&"
import style0 from "./page.footer.vue?vue&type=style&index=0&id=640f6b36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f6b36",
  null
  
)

export default component.exports